<div class="p-3 bg-white rounded-3">
  <!-- ===== WEB — TYPE 0 ===== -->
  <!-- <div class="d-flex justify-content-end pb-3">
    <button class="btn-gift-list" (click)="gotoGiftList()">Đổi xu lấy quà ngay!</button>
  </div> -->
  <div class="d-none d-lg-block d-xl-block d-xxl-block row pb-3" *ngIf="userWalletType0">
    <div class="pb-3">
      <div class="p-3 px-4 bg rounded-3 box-shadow text-white d-flex align-items-center justify-content-between">
        <div>
          <h5 class="pb-3">Ví Khả Dụng</h5>
          <div class="d-flex gap-1 gap-2">
            <h2 class="fw-bolder">{{ userWalletType0.balance | number: '1.0-0' }} Xu</h2>
          </div>
        </div>
        <div class="d-flex">
          <img src="assets/svg/coin.svg" style="width: 5rem; height: 4rem"  loading="lazy" />
        </div>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-between align-items-center gap-3">
      <input type="text" class="form-control" placeholder="Nhập mã voucher" [(ngModel)]="voucherCode" (keydown.enter)="submit()" />
      <button class="btn btn-submit" (click)="scanQRCode()">Quét mã QR</button>
      <button class="btn btn-submit" (click)="submit()">Xác nhận</button>
    </div> -->
  </div>

  <!-- ===== MOBILE — TYPE 0 ===== -->
  <div *ngIf="userWalletType0" class="d-md-block d-sm-block d-lg-none d-xl-none bg-transparent">
    <div class="pb-3">
      <div class="p-3 px-4 bg rounded-3 box-shadow text-white d-flex align-items-center justify-content-between">
        <div>
          <h5 class="pb-3">Ví Khả Dụng</h5>
          <div class="d-flex gap-1 align-items-baseline gap-2">
            <h2 class="fw-bolder">{{ userWalletType0.balance | number: '1.0-0' }} Xu</h2>
          </div>
        </div>
        <div class="d-flex">
          <img src="assets/svg/coin.svg" style="width: 5rem; height: 4rem"  loading="lazy" />
        </div>
      </div>
    </div>

    <!-- <div class="d-flex align-items-center gap-2">
      <input type="text" class="form-control" placeholder="Nhập voucher" [(ngModel)]="voucherCode" (keydown.enter)="submit()" />
      <button class="btn btn-submit" (click)="scanQRCode()">Quét mã QR</button>
      <button class="btn btn-submit" (click)="submit()">Xác nhận</button>
    </div> -->
  </div>

  <!-- ===== Lịch sử TYPE 0 ===== -->
  <div *ngIf="walletHistory0.length" class="tracking-wrapper table-responsive py-3">
    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let col of headerColumns" scope="col">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of walletHistory0">
          <td><h6>{{ item.sourceRef }}</h6></td>
          <td><h6>{{ item.note }}</h6></td>
          <td>
            <h6 class="theme-color">{{ item.amount > 0 ? '+' + item.amount.toLocaleString() : '' }}</h6>
          </td>
          <td>
            <h6 style="color:#b50303">{{ item.amount < 0 ? item.amount.toLocaleString() : '' }}</h6>
          </td>
          <td><h6>{{ item.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</h6></td>
          <td><h6>{{ item.walletBalanceAfterTransaction.toLocaleString() }}</h6></td>
        </tr>
      </tbody>
    </table>
    <app-pagination
      [total]="pagination0.totalItems"
      [currentPage]="pagination0.currentPage"
      [pageSize]="pagination0.pageSize"
      (setPage)="setPaginate($event, 0)"
    >
    </app-pagination>
  </div>
  <div *ngIf="walletHistory0.length == 0" class="pb-5">
    <h4>Chưa có giao dịch nào</h4>
  </div>

  <!-- ===== WEB — TYPE 2 ===== -->
  <div class="d-none d-lg-block d-xl-block d-xxl-block row pb-3" *ngIf="userWalletType2">
    <div class="pb-3">
      <div class="p-3 px-4 bg rounded-3 box-shadow text-white d-flex align-items-center justify-content-between" style="background:#3c4b64">
        <div>
          <h5 class="pb-3">Ví Chưa Khả Dụng</h5>
          <div class="d-flex gap-1 gap-2">
            <h2 class="fw-bolder">{{ userWalletType2.balance | number: '1.0-0' }} Xu</h2>
          </div>
        </div>
        <div class="d-flex">
          <img src="assets/svg/coin.svg" style="width: 5rem; height: 4rem"  loading="lazy" />
        </div>
      </div>
    </div>
    <!-- (Tuỳ policy) Không cho nhập voucher cho type 2 nếu không cần -->
  </div>

  <!-- ===== MOBILE — TYPE 2 ===== -->
  <div *ngIf="userWalletType2" class="d-md-block d-sm-block d-lg-none d-xl-none bg-transparent">
    <div class="pb-3">
      <div class="p-3 px-4 bg rounded-3 box-shadow text-white d-flex align-items-center justify-content-between" style="background:#3c4b64">
        <div>
          <h5 class="pb-3">Ví Chưa Khả Dụng</h5>
          <div class="d-flex gap-1 align-items-baseline gap-2">
            <h2 class="fw-bolder">{{ userWalletType2.balance | number: '1.0-0' }} Xu</h2>
          </div>
        </div>
        <div class="d-flex">
          <img src="assets/svg/coin.svg" style="width: 5rem; height: 4rem"  loading="lazy" />
        </div>
      </div>
    </div>
  </div>

  <!-- ===== Lịch sử TYPE 2 ===== -->
  <div *ngIf="walletHistory2.length" class="tracking-wrapper table-responsive py-3">
    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let col of headerColumns" scope="col">{{ col }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of walletHistory2">
          <td><h6>{{ item.sourceRef }}</h6></td>
          <td><h6>{{ item.note }}</h6></td>
          <td>
            <h6 class="theme-color">{{ item.amount > 0 ? '+' + item.amount.toLocaleString() : '' }}</h6>
          </td>
          <td>
            <h6 style="color:#b50303">{{ item.amount < 0 ? item.amount.toLocaleString() : '' }}</h6>
          </td>
          <td><h6>{{ item.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</h6></td>
          <td><h6>{{ item.walletBalanceAfterTransaction.toLocaleString() }}</h6></td>
        </tr>
      </tbody>
    </table>
    <app-pagination
      [total]="pagination2.totalItems"
      [currentPage]="pagination2.currentPage"
      [pageSize]="pagination2.pageSize"
      (setPage)="setPaginate($event, 2)"
    >
    </app-pagination>
  </div>
  <div *ngIf="walletHistory2.length == 0">
    <h4>Chưa có giao dịch nào</h4>
  </div>
</div>

<!-- ===== MODAL QUÉT QR (giữ nguyên) ===== -->
<ng-template #scanModal let-modal>
  <div class="modal-header justify-content-space-between">
    <h3 class="fw-semibold" style="font-weight: 700">Quét Mã Voucher</h3>
    <img src="assets/svg/register/Cancel.svg" id="login_modal_close_btn" (click)="modal.dismiss('Cross click')" class="position-absolute" style="right: 1rem;"  loading="lazy" />
  </div>

  <ng-container *ngIf="!hasCameraPermission">
    <div class="modal-body address-form text-center">
      <p>Vui lòng cấp quyền truy cập camera để quét mã QR.</p>
      <button class="btn btn-submit mx-auto" (click)="checkCamera()">Cấp quyền</button>
    </div>
  </ng-container>

  <ng-container>
    <div class="modal-body address-form" *ngIf="hasCameraPermission">
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3 my-1">
          <select #select1 (change)="action.playDevice(select1.value)" class="form-select form-select-md">
            <option [value]="null" selected>Chọn Camera</option>
            <option *ngFor="let c of action.devices.value; let i = index" [value]="c.deviceId" [selected]="i == action.deviceIndexActive">
              {{ c.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <ngx-scanner-qrcode #action="scanner" [config]="config" (event)="onEvent($event, action)"></ngx-scanner-qrcode>

    <p *ngIf="action.isLoading">⌛ Loading...</p>
    <div class="justify-content-center" [class]="hasCameraPermission ? 'd-flex' : 'd-none'">
      <button id="btnStart" class="btn" [class.btn-info]="!action.isStart" [class.btn-warning]="action.isStart" [disabled]="action.isLoading" (click)="handle(action, action.isStart ? 'stop' : 'start')">
        <img [src]=" action.isStart ? 'https://id1945.github.io/images/svg/camera-off.svg' : 'https://id1945.github.io/images/svg/camera-on.svg' " width="30px"  loading="lazy" />
      </button>
      <button class="btn" [class.btn-info]="!action.isStart" [class.btn-warning]="action.isStart" [disabled]="!action.isStart" (click)="handle(action, action.isPause ? 'play' : 'pause')">
        <img [src]=" action.isPause ? 'https://id1945.github.io/images/svg/play.svg' : 'https://id1945.github.io/images/svg/pause.svg' " width="30px"  loading="lazy" />
      </button>
    </div>
  </ng-container>
</ng-template>

<app-welcome-back-reward-modal #welcomeBackRewardModal [reward]="reward"></app-welcome-back-reward-modal>
